import React from 'react';
import { HelpButtonContainer } from '../help/HelpButtonContainer';
import { Flex, Top } from '../../components/Flex';
import { Label } from '../../components/Text';
import { UserMenuContainer } from '../user/UserMenuContainer';
import { useSelector } from 'react-redux';
import { SupportButtonContainer } from '../support/SupportButtonContainer';
import { UploadProgressContainer } from '../uploads/UploadProgressContainer';
import { useUrlParams } from '../content/useUrlParams';
import { find, flattenDeep, has } from 'lodash';
import { DownloadsButtonContainer } from '../downloads/DownloadsButtonContainer';

const TopPanel = ({ pathname }) => {
    const { urlParams } = useUrlParams();
    const { filter } = urlParams;
    const { isAdmin, grant } = useSelector(state => state.user.grants);
    const filterName = useSelector(state => {
        if (filter !== undefined) {
            let selectedFilter = find(flattenDeep(Object.values(state.data.filters)), o => o.id == filter);
            if (selectedFilter && has(selectedFilter, "name")) {
                return selectedFilter.name;
            }
        }
        return null
    });

    const title = {
        organisations: isAdmin ? "organizations" : "organization",
        users: "users",
        issues: "issues",
        packages: "packages",
        audit: "audit",
        contracts: pathname === "/contracts/all" ? "organizations contracts" : "contracts",
        services: {
            shc: "system health check"
        },
        licenses: "licenses"
    }

    const getTitle = () => {
        if (!grant) {
            return null;
        }
        const urlParts = pathname.split("/"), page = urlParts[1], tab = urlParts[2];
        if (Object.keys(title).includes(page)) {
            if (page && tab && title[page][tab] && isNaN(tab) && typeof title[page][tab] === "string") {
                return title[page][tab];
            };

            if (page && title[page] && typeof title[page] === "string") {
                return title[page];
            };

            if (["audit", "services"].includes(page)) {
                return page;
            }
        };

        return "";
    };

    return (
        <Top>
            <Flex align="center" gap={{ right: 8 }}>
                <Label size="18px" capitalize bold>{getTitle()}</Label>
                {filterName ? <Label size="18px" capitalize bold>[{filterName}]</Label> : null}
            </Flex>
            <Flex gap={{ right: 16 }}>
                <DownloadsButtonContainer />
                <UploadProgressContainer />
                <HelpButtonContainer />
                <SupportButtonContainer />
                <UserMenuContainer />
            </Flex>
        </Top>
    )
};

export { TopPanel };